import React, { Component } from "react";
import Classes from "./style.module.css";
import "./thousandthree.css"
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { GoSearch } from "react-icons/go";

export default class Thousandthree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defVal: [],
            value: [],
            isUpdating: false,
            selectAllChecked: true,
            searchTerm:""
        };
        this.storeValue = this.storeValue.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.initializeValues();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filterData !== this.props.filterData || prevProps.defdata !== this.props.defdata) {
            this.setState({ isUpdating: false, selectAllChecked: true });
            this.initializeValues();
            // this.setState({searchTerm:""})
        }
    }


    initializeValues() {
        const parseValues = (data) => (data.includes(",") ? data.split(",") : [data]);

        const value = parseValues(this.props.filterData);
        const defVal = parseValues(this.props.defdata);

        const selectAllChecked = defVal.length > 0 && value.every((val) => defVal.includes(val));

        this.setState({
            defVal,
            value,
            selectAllChecked,
            isUpdating: true
        });
    }

    storeValue(e) {
        const { value, checked } = e.target;
        let updatedValues = [...this.state.defVal];

        if (checked) {
            updatedValues.push(value);
        } else {
            updatedValues = updatedValues.filter((val) => val !== value);
        }

        this.setState({ defVal: updatedValues });
        this.props.onChange(updatedValues.join(","), value);
    }

    selectAllClick(e) {
        const checked = e.target.checked;
        this.setState({ selectAllChecked: checked });

        const newValues = checked ? [...this.state.value] : [];
        this.setState({ defVal: newValues });
        this.props.onChange(newValues.join(","), "selectall");
    }

    handleSearch(e) {
        this.setState({ searchTerm: e.target.value });
    }

    render() {
        const { isUpdating, selectAllChecked, searchTerm, value, defVal } = this.state;

        const filteredValues = value.filter((val) =>
            val.toLowerCase().includes(searchTerm.toLowerCase())
        );

        return (
            <>
                {isUpdating ? (
                    <div className={`row`} >
                       
                       <div className="col-md-6" >
                       <div style={{ padding: "10px 0" }}>
                            
                             <div className='textsearch' style={{width:"100%"}}>
                                  <input
                                    className="textinp2"
                                    type="text"
                                    placeholder="Search..."
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    
                                    autoFocus={true}
                                  />
                                  <GoSearch 
                                    className="searchtextinp"
                                    
                                  />
                                </div>
                        </div>
                       </div>

                        <div className="col-md-6" style={{ display: "flex", alignItems: "center", marginBottom: "5px", justifyContent: "flex-end" , paddingLeft:"10px" }}>

                        <FormControl component="fieldset">
                        <FormGroup aria-label="position" row>
                        
                                       <FormControlLabel
            key={"selectall"}
            value={"selectall"}
            control={
              <Checkbox
                sx={{
                  color: '#29B6F6',
                  '&.Mui-checked': {
                    color: '#29B6F6',
                  },
                }}
                checked={selectAllChecked}
                onChange={(e) => this.selectAllClick(e)}
              />
            }
            label={"Select All"}
            sx={{ display: 'block',mb: '-4px', padding: 0 ,color: 'gray'}} 
            // onClick={(e) => e.stopPropagation()}
          />
                                       
                                  
                                
                         </FormGroup>
                         </FormControl>
                        </div>
                        <hr style={{ color: "grey" }} />
<div className={Classes.overflow}   style={{ maxHeight: "300px", overflow: "auto" }}>

<FormControl component="fieldset" className="px-3">
                        <FormGroup aria-label="position" row>
                        {filteredValues.length > 0 ? (
                            filteredValues.map((val, index) => {
                                const checked = defVal.includes(val);
                                return (
                                    <div className="col-md-6" key={index} style={{ display: "flex"}}>
                                       <FormControlLabel
            key={val}
            value={val}
            control={
              <Checkbox
                sx={{
                  color: '#29B6F6',
                  '&.Mui-checked': {
                    color: '#29B6F6',
                  },
                }}
                checked={checked}
                onChange={(e) => this.storeValue(e)}
              />
            }
            label={val}
            sx={{ display: 'block',mb: '-4px', padding: 0 ,color: 'gray'}} 
            onClick={(e) => e.stopPropagation()}
          />
                                       
                                       
                                    </div>
                                );
                            })
                        ) : (
                            <p style={{ textAlign: "center", color: "gray" }}>No results found</p>
                        )}
                         </FormGroup>
                         </FormControl>
</div>
                    </div>
                ) : (
                    "Loading..."
                )}
            </>
        );
    }
}

 {/* <input
                                            type="checkbox"
                                            id={val}
                                            value={val}
                                            name={val}
                                            checked={checked}
                                            onChange={(e) => this.storeValue(e)}
                                            style={{ width: "20px", height: "20px" }}
                                        />
                                        <label htmlFor={val} style={{ paddingLeft: "10px", cursor: "pointer" }}>{val}</label> */}